'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxTicker } from './Ticker'
import { TickerProps } from './Ticker'

interface TickerBlokProps {
  blok: {
    title: TickerProps['title']
    items: any
    title_position: TickerProps['title_position']
  } & SbBlokData
}

const Ticker: FC<TickerBlokProps> = ({ blok }) => {
  const [items, setItems] = useState([])
  useEffect(() => {
    if (blok.items) {
      const itemsArray = blok.items.map((item: any) => {
        return {
          asset: {
            src: item.asset.filename,
            alt: item.asset.alt,
          },
        }
      })
      setItems(itemsArray)
    }
  }, [blok.assets])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxTicker title={blok.title} items={items} title_position={blok.title_position} />
    </div>
  )
}

export default Ticker
